import React from 'react';
import { Download, FolderDown, X } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { downloadBatch, downloadFolder } from '../../utils/downloadUtils';

/**
 * 批量下载操作栏
 */
const BatchDownloadBar = ({ selectedIds, totalCount, activeNode, projectId, onClearSelection }) => {
  const { getTheme } = useTheme();
  const theme = getTheme();
  const [downloading, setDownloading] = React.useState(false);

  if (selectedIds.length === 0) return null;

  const handleDownloadSelected = async () => {
    setDownloading(true);
    try {
      // selectedIds 是字符串，需要转为数字
      const numericIds = selectedIds.map(id => parseInt(id)).filter(id => !isNaN(id));
      await downloadBatch(numericIds);
    } catch (err) {
      console.error('批量下载失败:', err);
    } finally {
      setDownloading(false);
    }
  };

  const handleDownloadFolder = async () => {
    if (!activeNode || !projectId) return;
    setDownloading(true);
    try {
      const episodeId = activeNode.episodeId || null;
      const shotNumber = activeNode.shotNumber || null;
      await downloadFolder(projectId, episodeId, shotNumber);
    } catch (err) {
      console.error('文件夹下载失败:', err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="flex items-center justify-between px-4 py-2.5 shrink-0 animate-in fade-in slide-in-from-top-2 duration-200"
      style={{ borderTop: '1px solid var(--color-border-primary)', backgroundColor: 'var(--color-bg-tertiary)' }}>
      <div className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
        已选 <span style={{ color: theme.colors.accentPrimary, fontWeight: 600 }}>{selectedIds.length}</span> 项
        {totalCount > 0 && <span style={{ color: 'var(--color-text-muted)' }}> / 共 {totalCount} 个资源</span>}
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={handleDownloadSelected}
          disabled={downloading}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all disabled:opacity-50"
          style={{ backgroundColor: theme.colors.accentPrimary, color: 'white' }}
        >
          <Download size={13} />
          {downloading ? '下载中...' : '下载选中'}
        </button>

        {activeNode && activeNode.type !== 'category' && (
          <button
            onClick={handleDownloadFolder}
            disabled={downloading}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all disabled:opacity-50"
            style={{
              backgroundColor: 'var(--color-bg-primary)',
              color: 'var(--color-text-secondary)',
              border: '1px solid var(--color-border-primary)'
            }}
          >
            <FolderDown size={13} />
            下载当前文件夹
          </button>
        )}

        <button
          onClick={onClearSelection}
          className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs transition-all"
          style={{ color: 'var(--color-text-muted)' }}
        >
          <X size={13} />
          取消
        </button>
      </div>
    </div>
  );
};

export default BatchDownloadBar;
